/*! @pentacode/ui v0.1.0 */
import { formatCurrency as e, formatDay as t } from "../format.js";
import { t as n } from "../../line-0Qabwcym.js";
import { n as r, t as i } from "../../theme-BfnA-mmC.js";
//#region src/charts/presets/savings.ts
var a = {
	Ersparnis: i.positive,
	Gebühren: r[7]
};
function o(e) {
	return Math.round(e * 100) / 100 + 0;
}
function s(e, t) {
	let n = [];
	for (let { date: t, savings: r } of e) {
		if (r === void 0) break;
		n.push({
			x: t,
			series: "Ersparnis",
			value: o((n.at(-1)?.value ?? 0) + r)
		});
	}
	return {
		savings: n,
		fees: e.map(({ date: e }) => ({
			x: e,
			series: "Gebühren",
			value: t
		})),
		breakEvenDate: t > 0 ? n.find((e) => e.value >= t)?.x : void 0
	};
}
function c(r, o, c = {}) {
	let { savings: l, fees: u, breakEvenDate: d } = s(r, o);
	return n([...l, ...u], {
		...c,
		area: ["Ersparnis"],
		grouped: !0,
		threshold: {
			value: o,
			below: i.negative,
			above: i.positive
		},
		format: e,
		colors: a,
		markers: d ? [{
			x: d,
			label: `Break-even: ${t(d)}`
		}] : []
	});
}
//#endregion
export { s as cumulativeSavings, c as savingsChart, a as savingsColors };

//# sourceMappingURL=savings.js.map